const dropdownsNodes = document.querySelectorAll('[data-toggle="dropdown"]');
const menuItemNodes = document.querySelectorAll('.dropdown-menu');
const menuToggle = document.querySelector('#menu-toggle');

const main = document.querySelector('#main');

const activateDropdowns = () => {
  const dropdowns = Array.prototype.slice.call(dropdownsNodes);
  const menuItems = Array.prototype.slice.call(menuItemNodes);

  /**
   * Reset the active class from dropdown buttons that do not match event.target
   *
   * @param e event target
   */
  const removeActiveFromButtons = (e) => {
    // Get the targets parent
    const parent = e.target.parentElement;
    // Lopp every dropdown element
    dropdowns.forEach((dropdown) => {
      // If dropdown dataset do not match event target dataset AND parent dropdown do not have
      // active class > Remove active classes from buttons
      if (
        dropdown.dataset.menuId !== e.target.dataset.menuId &&
        !parent.parentElement.classList.contains('active')
      ) {
        dropdown.classList.remove('active');
        if (window.getComputedStyle(menuToggle).display === 'none') {
          main.classList.remove('modal-open');
        }
      }
    });
  };

  // Define a single event handler for both events
  const menuopenEvent = (dropdown, e) => {
    e.stopPropagation();

    // Get parent of event target
    const parent = e.target.parentElement;
    e.target.classList.toggle('active');

    const parentMenu = dropdown.parentElement;
    const nextMenuSibling = dropdown.nextElementSibling;

    // When we close menu from carrette. Remove fixed body if it does not have 'active' class
    //   if (!e.target.classList.contains('active')) {
    //     body.style.position = 'static';
    //   }
    removeActiveFromButtons(e);

    // Remove  show class if dropdown is not match the event targets next sibling
    // AND event target parent do not have show class
    menuItems.forEach((item) => {
      if (
        item !== nextMenuSibling &&
        !parent.parentElement.classList.contains('show')
      ) {
        item.classList.remove('show');
        main.classList.remove('modal-open');
      }
    });

    nextMenuSibling.classList.toggle('show');
    nextMenuSibling.focus({
      preventFocus: true,
    });

    parentMenu.classList.toggle('submenu-open');

    // Test if we do not have mobile hamburger visible and target dropdown button
    // does not have show class
    if (
      window.getComputedStyle(menuToggle).display === 'none' &&
      e.target.classList.contains('show')
    ) {
      // body.style.position = 'fixed';
      if (
        !main.classList.contains('modal-open') &&
        e.target.classList.contains('show')
      ) {
        main.classList.add('modal-open');
      }
    }
  };

  // Attach the same event handler to both 'mouseover' and 'click' events
  dropdowns.forEach((dropdown) => {
    dropdown.addEventListener('mouseover', (e) => menuopenEvent(dropdown, e));
    dropdown.addEventListener('click', (e) => menuopenEvent(dropdown, e));
  });

  window.addEventListener('click', (event) => {
    if (!event.target.matches('.dropdown-menu')) {
      menuItems.forEach((item) => {
        const parentMenu = item.parentElement;
        if (item.classList.contains('show')) {
          item.classList.remove('show');
          parentMenu.classList.remove('submenu-open');
        }
      });
    }
  });
};

export default activateDropdowns;
